"use strict";
exports.__esModule = true;
var TornadoLogic = /** @class */ (function () {
    function TornadoLogic() {
    }
    TornadoLogic.prototype.getFirstFactorActionNameFromInputs = function (appStructure, dataStructure, firstFactorName) {
        var result = {};
        var appProjects = appStructure.project.MENU;
        var inputList = dataStructure.included.Inputs;
        var inputKey = "";
        inputList.forEach(function (item) {
            if (item.Display == firstFactorName) {
                inputKey = item.Key;
            }
        });
        appProjects.forEach(function (item) {
            if (item.Parameters.InputKeys !== undefined && item.Parameters.InputKeys.indexOf(inputKey) != -1) {
                result = item;
            }
        });
        return result;
    };
    TornadoLogic.prototype.getCurrentTornadoDepth = function (appStructure) {
        var result = "";
        appStructure.project.MENU.forEach(function (item) {
            if (item.Command == "TORNADODIST") {
                result = item.Parameters.Depth;
            }
        });
        return result;
    };
    return TornadoLogic;
}());
exports["default"] = TornadoLogic;
//# sourceMappingURL=tornado-logic.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/tornado/app/js/logic/tornado-logic.js